import React, { useState, useRef } from "react";
import html2pdf from 'html2pdf.js';
import '../styles/HptScreens.css'; 
import logoElecnor from '../assets/logo_elecnor.jpg';

const BloqueoElectrico = ({ bloqueo, hpt, onSave, onCancel, isPdfMode = false }) => {
    // Estado local para escribir el candado dentro de las celdas operativas
    const [numCandado, setNumCandado] = useState(bloqueo.num_candado || '');
    
    // Referencia local para capturar el contenedor exacto y mandarlo a la impresora PDF
    const lotoPrintRef = useRef();

    // Controla si estamos en el momento de generar el PDF
    const [isPrinting, setIsPrinting] = useState(false);

    // Estilo común para celdas de firmas vacías del documento
    const celdaFirmaPlaceholder = (
        <span style={{ color: '#bbb', fontSize: '9px', fontStyle: 'italic' }}>
            Nombre, firma, fecha y hora
        </span>
    );

    // Función de exportación a PDF nativa de la hoja LOTO
    const handleImprimirHojaLoto = () => {
        setIsPrinting(true); // Oculta el input y pone texto plano

        // Damos 150ms a React para que actualice la vista antes de hacer la foto
        setTimeout(() => {
            const element = lotoPrintRef.current;
            const opt = {
                margin:       [8, 8, 8, 8],
                filename:     `LOTO_Bloqueo_${bloqueo.num_consignacion}.pdf`,
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2, useCORS: true, logging: false },
                jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
                pagebreak:    { mode: ['css', 'legacy'] }
            };
            
            // Genera el PDF y al terminar, vuelve a poner el input
            html2pdf().set(opt).from(element).save().then(() => {
                setIsPrinting(false);
            });
        }, 150);
    };

    // Renderizador para los bloques de firmas del pie de página
    const renderBloqueAutorizacion = (titulo) => (
        <div style={{ flex: 1, border: '1px solid #000', display: 'flex', flexDirection: 'column' }}>
            <div style={{ backgroundColor: '#90caf9', fontWeight: 'bold', fontSize: '10px', textAlign: 'center', padding: '4px', borderBottom: '1px solid #000', color: '#000' }}>
                {titulo.toUpperCase()}
            </div>
            <div style={{ display: 'flex', fontSize: '10px', height: '35px', alignItems: 'flex-end' }}>
                <div style={{ flex: 1, borderRight: '1px solid #000', height: '35px', fontSize: '9px', color: '#333'}}>Nombre:</div>
                <div style={{ flex: 1, borderRight: '1px solid #000', height: '35px', fontSize: '9px', color: '#333'}}>Fecha:</div>
                <div style={{ flex: 1, height: '35px', fontSize: '9px', color: '#333'}}>Firma:</div>
            </div>
        </div>
    );

    return (
        <div className={isPdfMode ? "pe-pdf-mode" : "pe-modal-overlay"}>
            {/* Contenedor principal con scrollbar en web por si la pantalla es pequeña */}
            <div className="pe-modal-content" style={{ maxWidth: '850px', backgroundColor: '#fff', padding: '20px', color: '#000', overflowY: 'auto', maxHeight: '90vh' }}>
                
                {/* AREA DE IMPRESIÓN SELECCIONADA POR EL REF */}
                <div ref={lotoPrintRef} style={{ backgroundColor: '#fff', padding: '5px', fontFamily: 'Arial, sans-serif' }}>
                    
                    {/* --- ENCABEZADO OFICIAL (Estructura image_2be5e0.png) --- */}
                    <header style={{ display: 'flex', border: '2px solid #000', borderBottom: 'none', alignItems: 'center' }}>
                        <div style={{ width: '25%', padding: '10px', display: 'flex', justifyContent: 'center', borderRight: '2px solid #000' }}>
                            <img src={logoElecnor} alt="Logo Elecnor" style={{ maxHeight: '45px' }} />
                        </div>
                        <div style={{ width: '75%', textAlign: 'center', backgroundColor: '#90caf9', padding: '8px' }}>
                            <h2 style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#000', textTransform: 'uppercase' }}>
                                ENCLAVAMIENTO ELECTRICO rev 01
                            </h2>
                            <div style={{ fontSize: '12px', fontWeight: 'bold', marginTop: '2px', color: '#000' }}>
                                TRABAJOS CON CORTE DE TENSION - OPERACION
                            </div>
                            <div style={{ fontSize: '11px', fontWeight: 'bold', marginTop: '2px', color: '#000' }}>
                                861001-ELO-5100-910-PRC-053
                            </div>
                        </div>
                    </header>

                    {/* --- MATRIZ DE CONFIGURACIÓN DE MANIOBRA CUADRICULADA --- */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #000', margin: 0 }}>
                        <tbody>
                            <tr style={{ height: '32px' }}>
                                <td style={{ border: '1px solid #000', padding: '6px', width: '25%', fontSize: '11px', textAlign: 'center', backgroundColor: '#fafafa' }}>Elemento de corte:</td>
                                <td style={{ border: '1px solid #000', padding: '6px', width: '25%', fontWeight: 'bold', fontSize: '12px', textAlign: 'center' }}>{bloqueo.ubicacion || 'S/U'}</td>
                                <td style={{ border: '1px solid #000', padding: '6px', width: '25%', textAlign: 'center', fontSize: '11px', backgroundColor: '#fafafa' }}>Descargo Nº:</td>
                                <td style={{ border: '1px solid #000', padding: '6px', width: '25%', fontWeight: 'bold', fontSize: '14px', color: '#b71c1c', textAlign: 'center' }}>{bloqueo.num_consignacion}</td>
                            </tr>
                            <tr style={{ height: '32px' }}>
                                <td style={{ border: '1px solid #000', padding: '6px', fontSize: '11px', textAlign: 'center', backgroundColor: '#fafafa' }}>Ubicación del elemento de corte:</td>
                                <td style={{ border: '1px solid #000', padding: '6px', fontWeight: 'bold', fontSize: '12px', textAlign: 'center' }}>{bloqueo.centro_cargas || 'S/C'}</td>
                                <td style={{ border: '1px solid #000', padding: '6px', fontSize: '11px', textAlign: 'center', backgroundColor: '#fafafa' }}>Permiso de trabajo Nº:</td>
                                <td style={{ border: '1px solid #000', padding: '6px', fontWeight: 'bold', fontSize: '13px', textAlign: 'center' }}>{hpt.numero_ptw || 'PENDIENTE'}</td>
                            </tr>
                            <tr style={{ height: '35px' }}>
                                <td style={{ border: '1px solid #000', padding: '5px', fontSize: '11px', textAlign: 'center', fontWeight: 'bold', backgroundColor: '#fafafa' }}>MAGNITUD</td>
                                <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', fontSize: '13px', textAlign: 'center', color: '#000' }}>{bloqueo.tension ? `${bloqueo.tension},00 V` : '0,00 V'}</td>
                                <td style={{ border: '1px solid #000', padding: '5px', fontSize: '11px', textAlign: 'center', fontWeight: 'bold', backgroundColor: '#fafafa' }}>TAG DEL EQUIPO</td>
                                <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', fontSize: '13px', textAlign: 'center', backgroundColor: '#fffde7' }}>{bloqueo.activo}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '8px', fontSize: '11px', textAlign: 'center', fontWeight: 'bold', backgroundColor: '#fafafa' }}>NOMBRE DEL EQUIPO A BLOQUEAR</td>
                                <td colSpan="3" style={{ border: '1px solid #000', padding: '8px', fontWeight: 'bold', fontSize: '12px', textTransform: 'uppercase' }}>{bloqueo.descripcion || 'SIN DESCRIPCIÓN'}</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* --- SECCIÓN DE PROTECCIONES FIJAS EN PLANTA --- */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #000', borderTop: 'none' }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '25%', borderRight: '1px solid #000', padding: '6px', fontSize: '10px', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#fafafa' }}>
                                    PROTECCIONES INDIVIDUALES<br />INSTRUCCIÓN ELECNOR<br />I.ELN.GEN-08.03 PUNTO 5.2
                                </td>
                                <td style={{ width: '50%', padding: '6px', fontSize: '9px', fontStyle: 'italic', lineHeight: '1.4' }}>
                                    Guantes aislantes correspondientes a la tensión de la instalación<br />
                                    Guantes ignífugos / mecánicos &nbsp;• Pantalla de protección facial inactínica<br />
                                    Casco de seguridad - barbuquejo &nbsp;• Banqueta o alfombra aislante<br />
                                    Ropa ignífuga y antiestática
                                </td>
                                <td style={{ width: '12.5%', borderLeft: '1px solid #000', borderRight: '1px solid #000', padding: '5px', fontSize: '11px', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#e0e0e0' }}>
                                    DESCARGO<br />DE ZONA<br />
                                </td>
                                <td style={{ width: '12.5%', padding: '5px', fontSize: '10px', fontWeight: 'bold', textAlign: 'center'}}>
                                    <span style={{ fontSize: '11px', color: '#000', display: 'block', marginTop: '2px' }}>{hpt.nombre_zona || 'CS'}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* --- TABLA OPERATIVA PRINCIPAL COMPLETA (3 FASES) --- */}
                    <div style={{ backgroundColor: '#ccc', padding: '5px', fontWeight: 'bold', fontSize: '11px', border: '2px solid #000', borderTop: 'none', borderBottom: 'none', textAlign: 'center', color: '#000', textTransform: 'uppercase' }}>
                        OPERACIONES A REALIZAR - REGLAS DE ORO ASOCIADAS
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #000' }}>
                        <thead>
                            <tr style={{ fontSize: '11px' }}>
                            <th style={{ border: '1px solid #000', width: '12%', textAlign: 'center', backgroundColor: '#e0e0e0', padding: '4px', verticalAlign: 'middle' }} rowSpan="2">Fase</th>
                            <th style={{ border: '1px solid #000', width: '48%', textAlign: 'center', backgroundColor: '#e0e0e0', padding: '4px', verticalAlign: 'middle' }} rowSpan="2">Operaciones Asociadas</th>
                            <th style={{ border: '1px solid #000', width: '18%', textAlign: 'center', backgroundColor: '#e0e0e0', padding: '4px', verticalAlign: 'middle' }} colSpan="3">Mto. Eléctrico</th>
                            <th style={{ border: '1px solid #000', width: '22%', textAlign: 'center', backgroundColor: '#e0e0e0', padding: '4px', verticalAlign: 'middle' }} rowSpan="2">REALIZADO/FIRMA</th>
                        </tr>
                        <tr style={{ fontSize: '10px' }}>
                            <th style={{ border: '1px solid #000', width: '6%', textAlign: 'center', backgroundColor: '#e0e0e0', padding: '4px', verticalAlign: 'middle' }}>Si</th>
                            <th style={{ border: '1px solid #000', width: '6%', textAlign: 'center', backgroundColor: '#e0e0e0', padding: '4px', verticalAlign: 'middle' }}>No</th>
                            <th style={{ border: '1px solid #000', width: '6%', textAlign: 'center', backgroundColor: '#e0e0e0', padding: '4px', verticalAlign: 'middle' }}>Np</th>
                        </tr>
                        </thead>
                        <tbody style={{ fontSize: '10.5px' }}>
                            
                            {/* --- FASE 1: DESCONEXIÓN (4 FILAS) --- */}
                            <tr style={{borderTop: '2px solid #000'}}>
                                <td rowSpan="4" style={{ border: '1px solid #000', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#90caf9' }}>Desconexión</td>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 1 EPIS BASICOS MANIOBRA - VERIFICAR TAG</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 2 RETIRAR BLOQUEO Y CIERRE DE INTERRUPTOR REGLA DE ORO 1 Y 2</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center', padding: '2px' }}>
                                    {isPdfMode || isPrinting ? (
                                        <span style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                            {numCandado || '—'}
                                        </span>
                                    ) : (
                                        <input 
                                            type="text" 
                                            value={numCandado} 
                                            onChange={(e) => setNumCandado(e.target.value)}
                                            style={{ width: '85%', textAlign: 'center', border: '1px solid #f57c00', fontWeight: 'bold', fontSize: '11px', borderRadius: '3px', padding: '2px' }}
                                            placeholder="Nº"
                                        />
                                    )}
                                </td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 3 VERIFICAR ARRANQUE EN DCS Y CAMPO</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 4 SEÑALIZAR ACTIVO BLOQUEADO Y ZONA TRABAJO REGLA DE ORO 5</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>

                            <tr style={{borderBottom: '2px solid #000'}}>
                            </tr>
                            <tr style={{borderBottom: '2px solid #000'}}>
                                <br></br>
                            </tr>

                            {/* --- FASE 2: CONEXIÓN (4 FILAS) --- */}
                            <tr>
                                <td rowSpan="4" style={{ border: '1px solid #000', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#90caf9' }}>Conexión</td>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 1 EPIS BASICOS MANIOBRA - VERIFICAR TAG</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 2 RETIRAR BLOQUEO Y CIERRE DE INTERRUPTOR REGLA DE ORO 1 Y 2</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>{numCandado || ''}</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 3 PUESTA EN SERVICIO DEL EQUIPO</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 4 RETIRADA SEÑALIZACION EN CAMPO REGLA DE ORO 5</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>

                            <tr style={{borderBottom: '2px solid #000'}}>
                            </tr>
                            <tr style={{borderBottom: '2px solid #000'}}>
                                <br></br>
                            </tr>

                            {/* --- FASE 3: PRUEBAS / MEDIDAS (3 FILAS) --- */}
                            <tr>
                                <td rowSpan="3" style={{ border: '1px solid #000', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#90caf9' }}>Pruebas/Medidas<br />y Ensayos</td>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 1 EPIS BASICOS MANIOBRA - VERIFICAR TAG</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 2 RETIRAR BLOQUEO Y CIERRE DE INTERRUPTOR REGLA DE ORO 1 Y 2</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #000', padding: '5px' }}>PASO 3 PUESTA EN SERVICIO DEL EQUIPO</td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', textAlign: 'center' }}></td>
                                <td style={{ border: '1px solid #000', paddingLeft: '5px', textAlign: 'center' }}>{celdaFirmaPlaceholder}</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* NOTA INTERMEDIA */}
                    <div style={{ border: '2px solid #000', borderTop: 'none', padding: '5px', fontSize: '10.5px', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#fffde7', color: '#b71c1c' }}>
                        AI FINALIZAR LAS PRUEBAS COMPROBAR QUE EL EQUIPO SE ENCUENTRA EN BLOQUEO (PASO 2 MANIOBRA DESCONEXION)
                    </div>

                    {/* --- BLOQUES DE MATRIZ DE AUTORIZACIONES (8 SECCIONES) --- */}
                    <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            {renderBloqueAutorizacion("Autoriza Bloqueo Electrico")}
                            {renderBloqueAutorizacion("Autoriza Retirada del Bloqueo Electrico")}
                        </div>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            {renderBloqueAutorizacion("Realiza Bloqueo Electrico")}
                            {renderBloqueAutorizacion("Retirada Bloqueo Electrico")}
                        </div>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            {renderBloqueAutorizacion("Verifica Bloqueo Electrico")}
                            {renderBloqueAutorizacion("Verifica retirada del Bloqueo Electrico")}
                        </div>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            {renderBloqueAutorizacion("Autoriza Pruebas/Medidas y Ensayos")}
                            {renderBloqueAutorizacion("Autoriza Final de Pruebas/Medidas y Ensayos")}
                        </div>
                    </div>
                </div>

                {/* --- SECCIÓN BOTONERA DE ACCIÓN DEL MODAL VISTA --- */}
                {!isPdfMode && (
                    <div className="pe-modal-actions" style={{ marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '12px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button type="button" className="btn-close" onClick={onCancel} style={{ padding: '6px 15px' }}>
                            ❌ Cerrar
                        </button>
                        <button type="button" className="btn-print" onClick={handleImprimirHojaLoto} style={{ backgroundColor: '#0288d1', color: '#fff', padding: '6px 15px', fontWeight: 'bold' }}>
                            🖨️ Imprimir Ficha
                        </button>
                        <button type="button" className="btn-save" style={{ backgroundColor: '#2e7d32', padding: '6px 15px' }} onClick={() => onSave(numCandado)}>
                            💾 Guardar Candado Nº {numCandado || 'Vacío'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BloqueoElectrico;